export default "__VITE_ASSET__BTTuNeZ0__$_?url__"